import property from 'lodash/property';
import { createSelector } from 'reselect';

import getParent from '../selectors';

export const getSecondaryParameter = state =>
  getParent(state).secondaryParameter;

export const getSecondaryParameterName = createSelector(
  getSecondaryParameter, property('name')
);

export const getSecondaryParameterType = createSelector(
  getSecondaryParameter, property('type')
);

export const isSecondaryParameterSelected = state =>
  !!getSecondaryParameterName(state);

export default getSecondaryParameter;
